import React from 'react'
import AirportsSelector from "./AirportsSelector/AirportsSelector";
import DatesRangePicker from "./DateRangePicker/DateRangePicker";
import RoundTripSelector from "./RoundTripSelector/RoundTripSelector";
import SubmitBtn from "./SubmitBtn/SubmitBtn";
import PassengerOptions from "./PassengerOptions/PassengerOptions";
import PromoCode from "./PromoCode/PromoCode";
import styles from './../../SearchWidget.module.scss';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {addCourse, removeCourse} from "../../../../services/flightCourse/actions";
import MultiCityAddRemoveBtn from "../FlightLegs/MultiCity/MultiCityAddRemoveBtn";
import ResponsiveDefinitions from "../../../../hoc/ResponsiveDefinitions/ResponsiveDefinitions";
import {withTranslation} from "react-i18next";
import imagineCardsImg from "../../../../assets/media/imagineCards.png";
import BookFlightOptions from "../BookFlightOptions/BookFlightOptions";

const FlightCourse = ({legsCount, multiCityMode, imagineMode, imagineCardType, isFirstCourse, isLastCourse, prevRef, nextRef, course, fastBookingMode,
  addCourse, removeCourse, originRef, destinationRef, datesRef, removeCourseBtnRef, addCourseBtnRef, showAddCourseOnAllLegs, t, Styles}) => {

    const ROUND_TRIP = React.createRef();
    const PAX_OPTIONS = React.createRef();
    const PROMO_CODE = React.createRef();
    const SUBMIT_BTN = React.createRef();

    const isMobile = !Styles.matches(false, false);
    const isDesktop = Styles.matches(false, false, false);
    const showAddCourse = showAddCourseOnAllLegs || isLastCourse;

    const cannotRemoveLeg = course.idx === 1 && legsCount === 2;
    const cannotAddLeg = legsCount === 8;
    const cannotSubmit = false;
    const availableAwardBookMode = imagineMode && imagineCardType;

    let datesNextRef = PAX_OPTIONS;
    if (!isDesktop) fastBookingMode = true;
    if (fastBookingMode) datesNextRef = SUBMIT_BTN;
    if (multiCityMode && !isFirstCourse) {
        datesNextRef = removeCourseBtnRef;
        if (cannotRemoveLeg) {
            datesNextRef = addCourseBtnRef;
            if (cannotAddLeg) {
                datesNextRef = SUBMIT_BTN;
                if (cannotSubmit) datesNextRef = nextRef;
            }
        }
    }

    const TAB_SEQUENCE = {
        AirportsSelector: {
            prevRef: prevRef ? prevRef : SUBMIT_BTN,
            originRef: originRef,
            destinationRef: destinationRef,
            nextRef: ((multiCityMode && !isFirstCourse) || fastBookingMode) ? datesRef : ROUND_TRIP
        },
        RoundTripSelector: {
            prevRef: destinationRef,
            containerRef: ROUND_TRIP,
            nextRef: datesRef
        },
        DatesRangePicker: {
            prevRef: multiCityMode && !isFirstCourse ? destinationRef : ROUND_TRIP,
            datesRef: datesRef,
            nextRef: datesNextRef,
        },
        PassengerOptions: {
            prevRef: datesRef,
            contRef: PAX_OPTIONS,
            nextRef: multiCityMode && nextRef ? nextRef : (availableAwardBookMode ? SUBMIT_BTN : PROMO_CODE),
        },
        MultiCityRemoveBtn: {
            prevRef: datesRef,
            contRef: removeCourseBtnRef,
            nextRef: cannotAddLeg ? (isLastCourse && !cannotSubmit ? SUBMIT_BTN : nextRef) : (showAddCourse ? addCourseBtnRef : nextRef)
        },
        MultiCityAddBtn: {
            prevRef: cannotRemoveLeg ? datesRef : removeCourseBtnRef,
            contRef: addCourseBtnRef,
            nextRef: isLastCourse && !cannotSubmit ? SUBMIT_BTN : nextRef,
        },
        PromoCode: {
            prevRef: PAX_OPTIONS,
            contRef: PROMO_CODE,
            nextRef: SUBMIT_BTN,
        },
        SubmitBtn: {
            prevRef: isLastCourse && multiCityMode
                ? (cannotAddLeg ? (cannotRemoveLeg ? datesRef : removeCourseBtnRef) : addCourseBtnRef) : (availableAwardBookMode ? PAX_OPTIONS : PROMO_CODE),
            contRef: SUBMIT_BTN,
            nextRef: nextRef ? nextRef : originRef,
        }
    };

    return (
        <div className={styles.flightCourseContainer}>
            <AirportsSelector
                prevRef={TAB_SEQUENCE.AirportsSelector.prevRef}
                originRef={TAB_SEQUENCE.AirportsSelector.originRef}
                destinationRef={TAB_SEQUENCE.AirportsSelector.destinationRef}
                nextRef={TAB_SEQUENCE.AirportsSelector.nextRef}
                multiCityMode={multiCityMode}
                course={course}
            />
            {isFirstCourse ?
                <RoundTripSelector
                    prevRef={TAB_SEQUENCE.RoundTripSelector.prevRef}
                    containerRef={TAB_SEQUENCE.RoundTripSelector.containerRef}
                    nextRef={TAB_SEQUENCE.RoundTripSelector.nextRef}
                    disableMultiCity={!isDesktop}
                /> : (isDesktop ? <div className={styles.roundTripContainer}/> : null)
            }
            <DatesRangePicker
                prevRef={TAB_SEQUENCE.DatesRangePicker.prevRef}
                datesRef={TAB_SEQUENCE.DatesRangePicker.datesRef}
                nextRef={TAB_SEQUENCE.DatesRangePicker.nextRef}
                course={course}
                multiCityMode={multiCityMode}
                animated
            />
            {isFirstCourse ?
                <PassengerOptions
                        prevRef={TAB_SEQUENCE.PassengerOptions.prevRef}
                        contRef={TAB_SEQUENCE.PassengerOptions.contRef}
                        nextRef={TAB_SEQUENCE.PassengerOptions.nextRef}
                        multiCityMode={multiCityMode}
                        animated
                /> : (
                    <div className={styles.buttonsAddOrRemoveLegContainer}>
                        <MultiCityAddRemoveBtn
                            prevRef={TAB_SEQUENCE.MultiCityRemoveBtn.prevRef}
                            contRef={TAB_SEQUENCE.MultiCityRemoveBtn.contRef}
                            nextRef={TAB_SEQUENCE.MultiCityRemoveBtn.nextRef}
                            clickHandler={() => removeCourse(course)}
                            animated={false}
                            title={t('Remove course')}
                            disabled={cannotRemoveLeg}><span className={'icon-sata-remove-course'} aria-hidden={true}/>
                        </MultiCityAddRemoveBtn>
                        &nbsp;&nbsp;
                        <MultiCityAddRemoveBtn
                            prevRef={TAB_SEQUENCE.MultiCityAddBtn.prevRef}
                            contRef={TAB_SEQUENCE.MultiCityAddBtn.contRef}
                            nextRef={TAB_SEQUENCE.MultiCityAddBtn.nextRef}
                            clickHandler={() => addCourse(course)}
                            animated={false}
                            title={t('Add course')}
                            disabled={cannotAddLeg}
                            hidden={!showAddCourse}><span className={'icon-sata-add-course'} aria-hidden={true}/>
                        </MultiCityAddRemoveBtn>
                    </div>
                )
            }
            {isFirstCourse ?
                (availableAwardBookMode
                    ?   <div className={styles.promoCodeContainer}>
                            <img src={imagineCardsImg} width='60px' height='35px' alt={'imagine cards'}/>
                        </div>
                    : <PromoCode
                        prevRef={TAB_SEQUENCE.PromoCode.prevRef}
                        contRef={TAB_SEQUENCE.PromoCode.contRef}
                        nextRef={TAB_SEQUENCE.PromoCode.nextRef}
                        disabled={multiCityMode}
                        animated
                    />) : (isDesktop ? <div className={styles.promoCodeContainer}/> : null)
            }
            {(isFirstCourse && !multiCityMode) || (isLastCourse && multiCityMode) ?
                <div className={styles.flightCourseSubmitBtnOutsideMobileContainer}>
                    <BookFlightOptions display={isMobile} classes={'sw-hidden-on-shrink'} inlineStyles={{backgroundColor: 'transparent', fontSize: '.5em'}}/>
                    <SubmitBtn
                        inlineStyles={isMobile ? {width: 'auto'} : {}}
                        prevRef={TAB_SEQUENCE.SubmitBtn.prevRef}
                        contRef={TAB_SEQUENCE.SubmitBtn.contRef}
                        nextRef={TAB_SEQUENCE.SubmitBtn.nextRef}
                        multiCityMode={multiCityMode}
                        animationOnSubmit={false}/>
                </div> : (isDesktop && !multiCityMode ? <div className={styles.flightCourseSubmitBtnContainer}/> : null)
            }
        </div>
    );
};

FlightCourse.propTypes = {
    legsCount: PropTypes.number,
    fastBookingMode: PropTypes.bool,
    isFirstCourse: PropTypes.bool,
    isLastCourse: PropTypes.bool,
    multiCityMode: PropTypes.bool,
    imagineMode: PropTypes.bool,
    imagineCardType: PropTypes.string,
    course: PropTypes.object,
    addCourse: PropTypes.func,
    removeCourse: PropTypes.func,
    originRef: PropTypes.any,
    destinationRef: PropTypes.any,
    datesRef: PropTypes.any,
    prevRef: PropTypes.any,
    nextRef: PropTypes.any,
    addCourseBtnRef: PropTypes.any,
    removeCourseBtnRef: PropTypes.any,
    showAddCourseOnAllLegs: PropTypes.bool,
    t: PropTypes.func,
};

FlightCourse.defaultProps = {
    legsCount: 1,
    fastBookingMode: false,
    isFirstCourse: false,
    isLastCourse: false,
    multiCityMode: false,
    imagineMode: false,
    imagineCardType: '',
    course: null,
    addCourse: () => null,
    removeCourse: () => null,
    originRef: null,
    destinationRef: null,
    datesRef: null,
    prevRef: null,
    nextRef: null,
    addCourseBtnRef: null,
    removeCourseBtnRef: null,
    showAddCourseOnAllLegs: true,
    t: s => s,
};

export default connect(null, {addCourse, removeCourse})(ResponsiveDefinitions(withTranslation()(FlightCourse)));
